import React, { Component } from "react";
import { Route } from "react-router";
import Layout from "./components/layouts/Layout";
import Home from "./components/views/Home";
import Log from "./components/views/Log";
import Login from "./components/views/Login";
import { IntlProvider, load, LocalizationProvider, loadMessages } from "@progress/kendo-react-intl";
import LoadingPanel from "./components/common/LoadingPanel";
import { history } from "./components/common/History";
import { RoleNames } from "./components/common/RoleNames";
import { authenticationService } from "./services/authentication.service";
import { PrivateRoute } from "./components/common/PrivateRoute";
import { appController } from "./controllers/app.controller";
import GlobalContext from "./GlobalContext.js";
import cookie from "react-cookies";
import Tools from "./components/views/Tools";
import { VersionNumber } from "./components/common/versionnumber";
import { logController } from "./controllers/log.controller";
// import log from "loglevel";
// import remote from "loglevel-plugin-remote";
// import moment from "moment/moment";
import { LogLevel } from "./enums";

import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import currencyData from "cldr-core/supplemental/currencyData.json";
import weekData from "cldr-core/supplemental/weekData.json";

import csNumbers from "cldr-numbers-full/main/cs/numbers.json";
import csLocalCurrency from "cldr-numbers-full/main/cs/currencies.json";
import csCaGregorian from "cldr-dates-full/main/cs/ca-gregorian.json";
import csDateFields from "cldr-dates-full/main/cs/dateFields.json";

import skNumbers from "cldr-numbers-full/main/sk/numbers.json";
import skLocalCurrency from "cldr-numbers-full/main/sk/currencies.json";
import skCaGregorian from "cldr-dates-full/main/sk/ca-gregorian.json";
import skDateFields from "cldr-dates-full/main/sk/dateFields.json";

import plNumbers from "cldr-numbers-full/main/pl/numbers.json";
import plLocalCurrency from "cldr-numbers-full/main/pl/currencies.json";
import plCaGregorian from "cldr-dates-full/main/pl/ca-gregorian.json";
import plDateFields from "cldr-dates-full/main/pl/dateFields.json";

import csKendoMessages from "./components/common/messages/cs.json";
import skKendoMessages from "./components/common/messages/sk.json";
import plKendoMessages from "./components/common/messages/pl.json";

import "@progress/kendo-theme-bootstrap/dist/all.css";

import "./App.css";

// const customJSON = (log) => ({
//     message: log.message,
//     level: log.level.label,
//     timestamp: log.timestamp,
//     stacktrace: log.stacktrace
// });

// remote.apply(log, { format: customJSON, url: "/api/log/clientlogger", timestamp: () => moment().toISOString(true) });

// log.enableAll();

load(
    likelySubtags,
    currencyData,
    weekData,
    csLocalCurrency,
    csNumbers,
    csCaGregorian,
    csDateFields,
    skLocalCurrency,
    skNumbers,
    skCaGregorian,
    skDateFields,
    plLocalCurrency,
    plNumbers,
    plCaGregorian,
    plDateFields
);

function fetchLanguageDictionaries(component) {
    var languageDictionariesLastUpdated = sessionStorage.getItem("languageDictionariesLastUpdated");
    var languageDictionaries = sessionStorage.getItem("languageDictionaries");

    appController.getLanguageDictionariesLastUpdated().then((result) => {
        if (languageDictionariesLastUpdated && languageDictionariesLastUpdated >= result.lastUpdated && languageDictionaries !== null) {
            var dictionary = JSON.parse(languageDictionaries);
            loadMessagesFromLanguageDictionaries(dictionary);
            component.setState({ loading: false });
        } else {
            component.setState({ loading: false });

            appController.getLanguageDictionaries().then((dictionary) => {
                dictionary["cs"] = { ...dictionary["cs"], ...csKendoMessages };
                dictionary["sk"] = { ...dictionary["sk"], ...skKendoMessages };
                dictionary["pl"] = { ...dictionary["pl"], ...plKendoMessages };
                loadMessagesFromLanguageDictionaries(dictionary);
                sessionStorage.setItem("languageDictionaries", JSON.stringify(dictionary));
                component.setState({ loading: false });

                appController.getLanguageDictionariesLastUpdated().then((updatedResult) => {
                    sessionStorage.setItem("languageDictionariesLastUpdated", updatedResult.lastUpdated);
                    logController.logMessage(
                        "Language dictionaries was refreshed from server to the last updated " + updatedResult.lastUpdated,
                        LogLevel.Information
                    );
                });
            });
        }
    });
}

function loadMessagesFromLanguageDictionaries(dictionary) {
    loadMessages(dictionary["cs"], "cs");
    loadMessages(dictionary["sk"], "sk");
    loadMessages(dictionary["pl"], "pl");
}

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentUser: null,
            isAdministrator: false,
            isVyvojar: false,
            globalContext: {
                language: "sk",
                changeLanguage: this.changeLanguage
            }
        };
        fetchLanguageDictionaries(this);

        logController.logMessage(`Device Screen Resolution: ${window.screen.width} x ${window.screen.height}; Device Pixel Ration: ${window.devicePixelRatio}`);
        logController.logMessage(`Verze v prohlížeči: ${localStorage.getItem("version")}; Verze dostupná na serveru: ${VersionNumber}`);

        // appController.getLastVersion().then((data) => {
        //     localStorage.setItem("version", data.version);
        // });

        // appController.getLastInformationalVersion().then((data) => {
        //     localStorage.setItem("informationalVersion", data.version);
        // });
    }

    displayName = App.name;

    componentDidMount() {
        authenticationService.currentUser.subscribe((x) =>
            this.setState({
                currentUser: x,
                isAdministrator: x && x.role === RoleNames.Administrator,
                isVyvojar: x && x.role === RoleNames.Vyvojar
            })
        );
    }

    logout() {
        authenticationService.logout();
        history.push("/login");
    }

    changeLanguage = (selectedLanguage) => {
        const maxAge = 60 * 30;
        const expires = new Date();
        expires.setDate(Date.now() + 1000 * maxAge);
        cookie.save("selectedLanguage", selectedLanguage, { path: "/", expires, maxAge });

        var globalContextState = this.state.globalContext;
        globalContextState.language = selectedLanguage;
        this.setState({
            globalContext: globalContextState
        });
    };

    render() {
        let contents = this.state.loading ? (
            <LoadingPanel />
        ) : (
            <LocalizationProvider language={this.state.globalContext.language}>
                <IntlProvider locale={this.state.globalContext.language}>
                    <GlobalContext.Provider value={this.state.globalContext}>
                        <Layout>
                            <PrivateRoute exact path="/" component={Home} />
                            <PrivateRoute exact path="/tools" component={Tools} />
                            <PrivateRoute exact path="/log" component={Log} />
                            <Route path="/login" component={Login} />
                        </Layout>
                    </GlobalContext.Provider>
                </IntlProvider>
            </LocalizationProvider>
        );

        return <React.Fragment>{contents}</React.Fragment>;
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js